import { render, staticRenderFns } from "./PageFollowingSettings.vue?vue&type=template&id=31c10587&"
import script from "./PageFollowingSettings.vue?vue&type=script&lang=ts&"
export * from "./PageFollowingSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports